import React from 'react';
import { twJoin } from 'tailwind-merge';
import { CartBundleComponent } from '../CartItem/cart-bundle-component/cart-bundle-component';
import { CartItemComponent } from '../CartItem/cart-product-component/cart-product-component';
import { CartItemsListProps } from './types/CartItemsListProps';

function CartItemsList({
  cartItems: { bundles, products },
  disableUpdate,
  variant,
  currency,
}: Readonly<CartItemsListProps>) {
  return (
    <ul className={twJoin('divide-y divide-neutral-10')}>
      {bundles?.map((bundle, index) => (
        <li key={`${bundle.cartBundleId}-${index}`}>
          <CartBundleComponent
            bundle={bundle}
            disableUpdate={disableUpdate}
            variant={variant}
            currency={currency}
          />
        </li>
      ))}
      {products?.map((product, index) => (
        <li key={`${product.cartItemId}-${index}`}>
          <CartItemComponent
            product={product}
            disableUpdate={disableUpdate}
            variant={variant}
            currency={currency}
          />
        </li>
      ))}
    </ul>
  );
}

export default CartItemsList;
